<template>
	<div><full-calendar ref="fullCalendar" selectable :options="calendarOptions" :header="false" /></div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';

export default {
	components: {
		FullCalendar
	},
	props: ['i', 'h', 'w', 'user'],
	mounted() {
		new ResizeObserver(this.onResize).observe(this.$el);
		const api = this.$refs.fullCalendar.getApi();
		this.api = api;
	},
	computed: {
		langCd() {
			const defaultLangCd = 'en';
			const lang = (_.get(this, `user.langCd`) || defaultLangCd).slice(0, 2);
			return lang;
		},
		calendarOptions() {
			return {
				plugins: [dayGridPlugin],
				initialView: 'dayGridMonth',
				height: '100%',
				expandRows: true,
				locale: this.langCd
			};
		}
	},
	data() {
		return {
			api: null
		};
	},
	methods: {
		onResize(e) {
			this.api.updateSize();
		}
	}
};
</script>
